import React, { useEffect, useState } from 'react';
import { Link, useHistory } from "react-router-dom";
import { useGlobal } from 'reactn';
import { useTranslation } from 'react-i18next';

import useLocalStorage from "stores/useLocalStorage.js";
import { useAuth } from 'stores/auth';
import { useApi } from 'stores/api';
import { SERVICE_TYPE, ADDRESS_TYPE, PAYMENT_TYPE } from 'stores/const';
import { fmtDatetime, roundMinutes } from 'stores/utils';
import Loader from 'components/Loader';
import AddressBlockRO from 'components/AddressBlockRO';
import Stepper from 'components/Stepper';
import FixedBottom from 'components/FixedBottom';

const BWOverview = (props) => {
  const history = useHistory();
  const api = useApi();
  const auth = useAuth();
  const { t } = useTranslation(['wizard-overview']);

  const [LSIsGuestBooking] = useLocalStorage('ls_igb');
  const [LSGuestData] = useLocalStorage('ls_gd');
  const [LSObjectDetailsMap] = useLocalStorage('ls_odm');

  const [masterData] = useGlobal('masterData');
  const [validationErrors, setValidationErrors] = useState([]);
  const [orderId] = useGlobal('orderId');
  const [orderData] = useGlobal('orderData');
  const [searchParams] = useGlobal('searchParams');
  const [currentTxnId, setCurrentTxnId] = useGlobal('currentTxnId');
  const [currentObjId, setCurrentObjId] = useGlobal('currentObjId')
  const [modalProps, setModalProps] = useGlobal('modalProps');
  const [showLoader, setShowLoader] = useGlobal('showLoader');
  const [isAgbAccepted, setIsAgbAccepted] = useGlobal('isAgbAccepted');
  const [isSameTimePeriod, setIsSameTimePeriod] = useGlobal('isSameTimePeriod');
  const [showVoucherSec, setShowVoucherSec] = useState(false);
  const [voucherCode, setVoucherCode] = useState('');
  const [isValidCode, setIsValidCode] = useState(false);

  const [businessPartner, setBusinessPartner] = useState({
    Email: '',
    FirstName: '',
    Name: '',
    Phone: '',
    refSalutationId: '',
  });
  const [addressPost, setAddressPost] = useState({
    Street: '',
    AddressAddition: '',
    City: '',
    PostalCode: '',
    refAddressTypeId: ADDRESS_TYPE.POSTAL,
    refCountryId: '',
  });
  const [addressBill, setAddressBill] = useState({
    Street: '',
    AddressAddition: '',
    City: '',
    PostalCode: '',
    refAddressTypeId: ADDRESS_TYPE.BILLING,
    refCountryId: '',
  });

  const [showAddressBlocks, setShowAddressBlocks] = useState(true);
  const toggleAddressBlocks = e => { e.preventDefault(); setShowAddressBlocks(!showAddressBlocks); }
  const editAddress = e => { history.push('/wizard/personaldata/edit'); };
  /* address related end */

  const currency = () => orderData.Currency_Name;

  const businessUnitId = () => orderData.OrderItem[0].RentalTransaction[0].refBusinessUnitId;

  const checkVoucherCode = async () => {
    setShowLoader(true);
    //var businessUnitId = orderData.OrderItem[0].RentalTransaction[0].refBusinessUnitId;
    const isValid = await api.checkVoucherCode(orderId, businessUnitId(), voucherCode);
    if (isValid) {
      setVoucherCode('');
    }
    setIsValidCode(isValid);
    setShowLoader(false);
  }


  const RenderServices = (props) => {
    let { services, txn, setTxn } = props;
    let svcTypes = [SERVICE_TYPE.BYRESERVATION, SERVICE_TYPE.SELECTABLE, SERVICE_TYPE.OBLIGATORY, SERVICE_TYPE.DESELECTABLE];
    return svcTypes.map((svcType, arrIndx) => {
      return services.filter(svc => svc.refRentalServiceTypeId === svcType)
        .map(svc => renderService(svc, arrIndx, txn, setTxn))
    })
  }

  const renderService = (svc, arrIndx, txn, setTxn) => {
    const removeService = async (svcId) => {
      setShowLoader(true);
      await api.removeService(txn.Id, svcId);
      await api.getOrderDetails(orderId);
      setShowLoader(false);
      // const newTxn = await api.removeService(txn.Id, svcId);
      // if (newTxn) {
      //   setTxn(newTxn);
      //   await api.getOrderDetails(orderId);
      // }
    };
    //if (svc.ResultPrice === 0) return null;
    return (
      <div className={`svc-container${svc.ResultPrice < 0 ? ' discount' : ''}`}>
        <div className="svc-name">{svc.Name}</div>
        {arrIndx < 2 && <div className="svc-actions">
          <a className="delete" onClick={() => removeService(svc.refRentalServiceId)}><i className="fa fa-trash" aria-hidden="true"></i></a>
        </div>}
        {(!masterData.organization.FreeOfCharge) && <div className="svc-price">{currency()} {svc.ResultPrice.toFixed(2)}</div>}
      </div>
    )
  }

  const RenderAccessories = (props) => {
    let { accessories, txn, setTxn } = props;

    const onIncreaseAccQuantity = async (acc) => {
      setShowLoader(true);
      let newQuantity = parseInt(acc.Quantity, 10) + 1;
      const maxQuantity = parseInt(acc.AccessoryRentalObject_Quantity, 10);
      if (newQuantity > maxQuantity) return;
      await api.updateAccessory(txn.Id, acc.refRentalObjectId, newQuantity);
      await api.getOrderDetails(orderId);
      setShowLoader(false);
      // const newTxn = await api.updateAccessory(txn.Id, acc.refRentalObjectId, newQuantity);
      // if (newTxn) {
      //   setTxn(newTxn);
      //   await api.getOrderDetails(orderId);
      // }
    }

    const onDecreaseAccQuantity = async (acc) => {
      setShowLoader(true);
      if ((acc.Quantity === 1 && acc.IsObligatory) || (acc.Quantity <= 0)) {
        setShowLoader(false);
        return;
      }
      let quantity = parseInt(acc.Quantity, 10) - 1;
      if (quantity < 0) return;
      await api.updateAccessory(txn.Id, acc.refRentalObjectId, quantity);
      await api.getOrderDetails(orderId);
      setShowLoader(false);
      // const newTxn = await api.updateAccessory(txn.Id, acc.refRentalObjectId, quantity);
      // if (newTxn) {
      //   setTxn(newTxn);
      //   await api.getOrderDetails(orderId);
      // }
    }

    return (
      <>
        {accessories.map((acc) => {
          return (
            <div className="acc-container">
              <div className="acc-name">{acc.Name}</div>
              <div className="acc-actions">
                <div className="acc-quantity">
                  <input readOnly={true} placeholder="000" value={acc.Quantity} />
                  <a className="minus" onClick={() => onDecreaseAccQuantity(acc)}><i className="fa fa-minus"></i></a>
                  <a className="plus" onClick={() => onIncreaseAccQuantity(acc)}><i className="fa fa-plus"></i></a>
                </div>
              </div>
              {(!masterData.organization.FreeOfCharge) && <div className="acc-price">{currency()} {acc.SumTotalPrice.toFixed(2)}</div>}
            </div>
          )
        })}
      </>
    );
  }

  // const renderAccessory = (acc) => {
  //   const onIncreaseAccQuantity = (accId) => { };
  //   const onDecreaseAccQuantity = (accId) => { };
  //   return (
  //     <div className="acc-container">
  //       <div className="acc-name">{acc.Name}</div>
  //       <div className="acc-actions">
  //         <div className="acc-quantity">
  //           <input placeholder="000" value={acc.Quantity} />
  //           <a className="minus" onClick={() => onDecreaseAccQuantity(acc.Id)}><i className="fa fa-minus"></i></a>
  //           <a className="plus" onClick={() => onIncreaseAccQuantity(acc.Id)}><i className="fa fa-plus"></i></a>
  //         </div>
  //       </div>
  //       <div className="acc-price">{acc.SumTotalPrice}</div>
  //     </div>
  //   )
  // }

  const showRemoveOrderItem = (txnId) => {
    setModalProps({
      ...modalProps,
      showModal: true,
      showCancel: true,
      okLabel: t("okLabelItem"),
      cancelLabel: t("cancelLabelItem"),
      messages: [t("cancelQuestionItem")],
      isDeletion: true,
      onOk: removeOrderItem,
      onOkData: { txnId }
    });
  }

  const removeOrderItem = async ({ txnId }) => {
    setShowLoader(true);
    var result = await api.removeOrderItem(orderId, txnId);
    if (result) {
      if (result === 'ORDER_CANCELLED') {
        console.log('removed order item');
        history.push('/search');
      } else {
        await api.getOrderDetails(orderId);
      }
    }
    setShowLoader(false);
  }

  const RenderOrderItem = (props) => {
    const { item, validationErrors } = props;
    const [txn, setTxn] = useState(item.RentalTransaction[0]);
    const txnId = txn.Id;
    const [rentalObject, setRentalObject] = useState(null);
    const [hasOptions, setHasOptions] = useState(false);
    const [note, setNote] = useState('');
    const [note2, setNote2] = useState('');
    const [bookingNote, setBookingNote] = useGlobal('bookingNote');
    const [bookingNote2, setBookingNote2] = useGlobal('bookingNote2');

    const onDecreaseQuantity = async () => {
      try {
        if (!validateFields({})) return;
        setShowLoader(true);
        let quantity = txn.Quantity;
        if (quantity === 1) return;
        quantity = parseInt(txn.Quantity, 10) - 1;
        await api.updateTransaction(txn.Id, note, note2, quantity);
        await api.getOrderDetails(orderId);
        setShowLoader(false);
      }
      catch (e) {
        console.log(e);
      }
    }
    const onIncreaseQuantity = async () => {
      try {
        if (!validateFields({})) return;
        setShowLoader(true);
        const quantity = parseInt(txn.Quantity, 10) + 1;
        await api.updateTransaction(txn.Id, note, note2, quantity);
        await api.getOrderDetails(orderId);
        setShowLoader(false);
      }
      catch (e) {
        console.log(e);
      }
    }
    const handleNote = (e) => {
      setNote(e.target.value);
    }
    const handleNote2 = (e) => {
      setNote2(e.target.value);
    }
    const setTxnBookingNote = (e) => {
      setBookingNote({ ...bookingNote, [txnId]: e.target.value });
    }
    const setTxnBookingNote2 = (e) => {
      setBookingNote2({ ...bookingNote2, [txnId]: e.target.value });
    }
    // const saveNotes = async () => {
    //   try {
    //     if (!validateFields({})) return;
    //     setShowLoader(true);
    //     let result = await api.updateTransaction(txn.Id, note, note2);
    //     console.log('update txn:' + result);
    //     if (result) {
    //       await api.getOrderDetails(orderId);
    //     }
    //     setShowLoader(false);
    //   } catch (error) {
    //     console.error(error);
    //   }
    // }
    const onClickOptions = (e) => {
      e.preventDefault();
      setCurrentTxnId(txn.Id);
      setCurrentObjId(txn.refRentalObjectId);
      history.push('/wizard/options/edit');
    }

    const getDiscountTitle = () => {
      return txn.TotalDiscountPrice > 0 ?
        t("totalSurcharge") :
        t("totalDiscount")
    }

    const getDiscountDetails = () => {
      let discounts = [];
      let hasFeeDiscount = txn.RentalFeeDiscountRate != 0;
      let hasSvcDiscount = txn.NormServiceDiscountPrice != 0;
      let hasConsDiscount = txn.ConsumableDiscountPrice != 0;
      if (hasFeeDiscount) {
        discounts.push(txn.RentalFeeDiscountName);
      }
      if (hasSvcDiscount) {
        discounts.push(txn.ServiceDiscountName);
      }
      if (hasConsDiscount) {
        discounts.push(txn.ConsumablesDiscountName);
      }
      let uniqueDiscounts = [...new Set(discounts)];
      return uniqueDiscounts.join(' / ');
    }

    // const checkValidation = (e) => {
    //   const fieldId = e.target.id;
    //   const isRequired = e.target.dataset.isRequired;
    //   const fieldValue = e.target.value.trim();
    //   if (isRequired) {
    //     if (fieldValue) {
    //       if (validationErrors.includes(fieldId)) {
    //         const valErrors = validationErrors.filter(item => item !== fieldId);
    //         setValidationErrors(valErrors);
    //       }
    //     }
    //     else {
    //       if (!validationErrors.includes(fieldId)) {
    //         setValidationErrors([...validationErrors, fieldId]);
    //       }
    //     }
    //   }
    // }

    useEffect(() => {
      const initValues = () => {
        if (bookingNote[txnId]) {
          setNote(bookingNote[txnId]);
        } else if (txn.LesseeNote) {
          setNote(txn.LesseeNote);
        }
        if (bookingNote2[txnId]) {
          setNote2(bookingNote2[txnId]);
        } else if (txn.LesseeNote2) {
          setNote2(txn.LesseeNote2);
        }
        if (LSObjectDetailsMap && LSObjectDetailsMap[txn.refRentalObjectId]) {
          let { rentalObject: rentalObj, objectOptions: objOptions } = LSObjectDetailsMap[txn.refRentalObjectId];
          if (rentalObj) {
            setRentalObject(rentalObj);
          }
          if (objOptions) {
            setHasOptions(objOptions.Services.length > 0 || objOptions.Accessories.length > 0);
          }
        }
      }
      if (txn) {
        console.log('initing txn values...');
        initValues();
      }
    }, []);

    if (!txn) return <div>Loading ...</div>;

    return (
      <div className="orderitem-container" key={txn.key || txn.Id}>
        <a className="orderitem-delete" onClick={() => showRemoveOrderItem(txn.Id)}><i className="fa fa-trash" aria-hidden="true"></i></a>
        <div className="orderitem-titlequantity">
          <h2 className="orderitem-title mali-blue">{txn.Name}</h2>
          <div className="orderitem-quantity">
            <input readOnly={true} placeholder="000" value={txn.Quantity} />
            <a className="minus" onClick={() => onDecreaseQuantity(txn.Id)}><i className="fa fa-minus"></i></a>
            <a className="plus" onClick={() => onIncreaseQuantity(txn.Id)}><i className="fa fa-plus"></i></a>
          </div>
        </div>
        <div className="orderitem-timefromto">
          <p><strong>{t("bookingFromTo", {
            from: fmtDatetime(roundMinutes(txn.PickupStartDate.substring(0, 19))),
            to: fmtDatetime(roundMinutes(txn.DropoffEndDate.substring(0, 19)))
          })}</strong></p>
        </div>
        {(!masterData.organization.FreeOfCharge) && <div className='orderitem-offerprice'>
          <div className="offerprice-label">{t("mainObjectPrice")}</div>
          <div className="offerprice-price">{currency()} {txn.MainObjectPrice.toFixed(2)}</div>
        </div>}
        {txn.RentalTransactionService.length > 0 && <div className="orderitem-services">
          <RenderServices services={txn.RentalTransactionService} txn={txn} setTxn={setTxn} />
        </div>}
        {txn.RentalTransactionAccessory.length > 0 && <div className="orderitem-accessories">
          <RenderAccessories accessories={txn.RentalTransactionAccessory} txn={txn} setTxn={setTxn} />
        </div>}
        {
          (!masterData.organization.FreeOfCharge) && txn.Deposit > 0 &&
          <div className="orderitem-deposit">
            <div className="deposit-label">{t("deposit")}</div>
            <div className="deposit-price">{currency()} {txn.Deposit.toFixed(2)}</div>
          </div>
        }
        {
          (!masterData.organization.FreeOfCharge) && txn.TotalDiscountPrice != 0 &&
          <div className="orderitem-discount">
            <div className="discount-title">{getDiscountTitle()}</div>
            <div className="discount-details">{getDiscountDetails()}</div>
            <div className="discount-price">{currency()} {txn.TotalDiscountPrice.toFixed(2)}</div>
          </div>
        }
        {
          (!masterData.organization.FreeOfCharge) && txn.VoucherCode &&
          <div className="voucher-entry">
            <div className="voucher-label">{txn.VoucherCode} <span>{t("discount")}</span></div>
            <div className="voucher-price">{currency()} {txn.VoucherPrice.toFixed(2)}</div>
          </div>
        }

        {hasOptions && <div className="orderitem-addmorebtn">
          <Link to={`/wizard/options/edit`} onClick={onClickOptions} className="add-option small">
            {t("addOption")} <i className="fa fa-plus" aria-hidden="true"></i>
          </Link>
        </div>}
        <div className="orderitem-notes">
          <div className={`notes1${validationErrors.includes('notes1-' + txnId) ? ' required-error' : ''}`}>
            <div className="title">{rentalObject?.NotesRequest ? rentalObject.NotesRequest + ' *' : 'Notizen'}</div>
            <div className="notes-text">
              <textarea class="notes" id={'notes1-' + txnId} data-is-required={rentalObject?.NotesRequest ? true : false}
                value={note} onChange={handleNote} onBlur={setTxnBookingNote}
                cols={50} maxLength={2000}></textarea>
            </div>
            {/* {!rentalObject?.NotesRequest2 && <div className="notes-save">
              <button onClick={saveNotes}>{t("saveNotes")} <i className="fa fa-floppy-o" aria-hidden="true"></i></button>
            </div>} */}
          </div>
          {
            rentalObject?.NotesRequest2 &&
            <div className={`notes2${validationErrors.includes('notes2-' + txnId) ? ' required-error' : ''}`}>
              <div className="title">{rentalObject?.NotesRequest2} *</div>
              <div className="notes-text">
                <textarea class="notes" id={'notes2-' + txnId} data-is-required={true}
                  value={note2} onChange={handleNote2} onBlur={setTxnBookingNote2}
                  cols={50} maxLength={2000}></textarea>
              </div>
              {/* <div className="notes-save">
                <button onClick={saveNotes}>{t("saveNotes")} <i className="fa fa-floppy-o" aria-hidden="true"></i></button>
              </div> */}
            </div>
          }
        </div>

        {(!masterData.organization.FreeOfCharge) && <div className="orderitem-subtotal">
          <div className="subtotal-label">{t("subtotal")}</div>
          <div className="subtotal-price">{currency()} {txn.SumChargeAmount_DBcalculate.toFixed(2)}</div>
        </div>}
      </div>
    );
  }

  const confirmSameTimePeriod = () => {
    setModalProps({
      ...modalProps,
      showModal: true,
      showCancel: true,
      size: 'compact',
      okLabel: t("yesSameTimePeriod"),
      cancelLabel: t("noSameTimePeriod"),
      messages: [t("isSameTimePeriod")],
      isDeletion: false,
      onOk: onYesSameTimePeriod,
      onCancel: onNoSameTimePeriod
    });
  }

  const onYesSameTimePeriod = async () => {
    setIsSameTimePeriod(true);
    const refreshed = await api.refreshOrder(orderId);
    if (refreshed) {
      history.push("/search");
    }
  }

  const onNoSameTimePeriod = async () => {
    setIsSameTimePeriod(false);
    const refreshed = await api.refreshOrder(orderId);
    if (refreshed) {
      history.push("/search");
    }
  }

  const showCancelOrder = () => {
    setModalProps({
      ...modalProps,
      showModal: true,
      showCancel: true,
      okLabel: t("okLabelOrder"),
      cancelLabel: t("cancelLabelOrder"),
      messages: [t("cancelQuestionOrder")],
      isDeletion: true,
      onOk: cancelOrder
    });
  }

  const cancelOrder = async () => {
    setShowLoader(true);
    const result = await api.cancelOrder(orderId);
    if (result) {
      history.push("/search");
    }
    setShowLoader(false);
    console.log('cancelled');
  }

  const onClickBookMore = async (e) => {
    e.preventDefault();
    confirmSameTimePeriod();
    // const refreshed = await api.refreshOrder(orderId);
    // if (refreshed) {
    //   history.push("/search");
    // }
  }

  const validateFields = (params) => {
    const invalid = [];
    const reqFields = document.querySelectorAll("[data-is-required=true]");
    if (reqFields.length) {
      reqFields.forEach(field => {
        if (!field.value.trim()) {
          invalid.push(field.id);
        }
      })
    }
    if (params.checkTerms && !isAgbAccepted) {
      invalid.push('agbCheckbox')
    }
    if (!invalid.length) {
      setValidationErrors([]);
      return true;
    } else {
      setValidationErrors([...invalid]);
      console.log('fill in the mandatory fields');
    }
    return false;
  }

  const hasValidCustomerData = (order) => {
    var result = true;
    if (order.refCustomerOrganizationBusinessPartnerId && order.ClientAddress_FirstLine) {
      order.OrderItem.forEach(item => {
        var txn = item.RentalTransaction[0];
        if (!(txn.CustomerEmail && txn.refCustomerOrganizationBusinessPartnerId)) {
          result = false;
        }
      })
      return result;
    }
    return false;
  }

  const onClickPayment = async (e) => {
    e.preventDefault();
    if (validateFields({ checkTerms: true })) {
      await saveAllNotes();
      if (!LSIsGuestBooking) {
        if (hasValidCustomerData(orderData)) {
          history.push('/wizard/payment');
        } else {
          console.log('customer data missing...');
          await api.setLesseeData(orderId);
          history.push('/wizard/payment');
        }
      } else {
        let result = await api.setGuestData(orderId);
        if (!result) return;
        history.push('/wizard/payment');
      }
    } else {
      window.setTimeout(() => {
        document.querySelector('.overviewerror-container')?.scrollIntoView({ behavior: "smooth" })
      }, 250);
    }
  }

  const onClickFinalize = async (e) => {
    e.preventDefault();
    if (validateFields({ checkTerms: true })) {
      await saveAllNotes();
      let result;
      if (LSIsGuestBooking) {
        result = await api.setGuestData(orderId);
        if (!result) return;
      } else {
        if (!hasValidCustomerData(orderData)) {
          console.log('customer data missing...');
          result = await api.setLesseeData(orderId);
          if (!result) return;
        }
      }
      result = await api.bookOrder(orderId, PAYMENT_TYPE.PERIODICALINVOICE, null, orderData.TotalPrice);
      if (result) {
        history.push('/wizard/confirmation');
      } else {
        console.log('Error finalizing booking.')
      }
    } else {
      window.setTimeout(() => {
        document.querySelector('.overviewerror-container')?.scrollIntoView({ behavior: "smooth" })
      }, 250);
    }
  }

  const saveAllNotes = async () => {
    var items2update = {};
    const notesFields = document.querySelectorAll("textarea.notes");
    notesFields.forEach(notesFld => {
      if (notesFld.value) {
        const notesId = notesFld.id;
        const itemId = notesId.replace(/notes1-|notes2-/g, '');
        if (!items2update[itemId]) {
          items2update[itemId] = { notes1: '', notes2: '' };
        }
        if (notesId.startsWith('notes1')) {
          items2update[itemId]['notes1'] = notesFld.value;
        }
        else if (notesId.startsWith('notes2')) {
          items2update[itemId]['notes2'] = notesFld.value;
        }
      }
    })

    for (const [key, value] of Object.entries(items2update)) {
      try {
        let result = await api.updateTransaction(key, value["notes1"], value["notes2"]);
      }
      catch (e) {
        console.log('error saving notes:' + key);
        console.log(e);
      }
    }
  }

  const redirectToHomepage = async () => {
    await api.clearOrder();
    history.push("/");
  }

  useEffect(() => {
    const fetchGuestData = () => {
      if (!LSGuestData) return;
      let { businessPartner, addressPost } = LSGuestData;
      setBusinessPartner(businessPartner);
      setAddressPost(addressPost);
    }
    const fetchPersonalData = async (lesseeId) => {
      try {
        console.log('fetching personal');
        let pData = await api.fetchPersonalData(lesseeId);
        if (pData) {
          setBusinessPartner(pData.OrganizationBusinessPartner[0]);
          let cobp = pData.CustomerOrganizationBusinessPartner[0];
          if (cobp) {
            let address = cobp.CustomerOrganizationBusinessPartnerAddress?.find(item => item.refAddressTypeId === ADDRESS_TYPE.POSTAL);
            if (address) {
              setAddressPost({ ...address });
            }
          }
        }
      }
      catch (e) {
        setModalProps({
          ...modalProps,
          showModal: true,
          messages: [t("sessionTimedOutMessage")],
          onOk: redirectToHomepage
        });
      }
    }
    const getOrderDetails = async () => {
      await api.getOrderDetails(orderId);
    }
    if (!orderId) {
      history.push('/search');
      return;
    }
    // todo PRA - what to do when the user is not logged in
    // if(!auth.user) {
    //   history.push('/personaldata/login');
    //   return;      
    // }
    setShowLoader(true);
    if (LSIsGuestBooking) {
      console.log('guest...');
      fetchGuestData();
    } else {
      if (auth.user) {
        console.log('authed and logged in...');
        fetchPersonalData(auth.user.Id);
      }
      else {
        console.log('authed but not logged in...');
        console.log('not logged in. redirecting to homepage.');
        history.push('/');
      }
    }
    // if (!orderData) {
    //   await getOrderDetails();
    // }
    getOrderDetails();
    setShowLoader(false);
    if (!LSObjectDetailsMap) {
      console.log('order objects could not be loaded');
      history.push('/search');
      return;
    } else {
      if (!masterData.organization.FreeOfCharge) {
        let objectId = orderData?.OrderItem[0]?.RentalTransaction[0]?.refRentalObjectId;
        let buVoucher = LSObjectDetailsMap[objectId]?.businessUnit?.Voucher;
        if (buVoucher && buVoucher.length > 0) {
          setShowVoucherSec(true);
        }
      }
    }
  }, []);

  useEffect(() => {
    const getOrderDetails = async () => {
      console.log('voucher code success...fetching order');
      await api.getOrderDetails(orderId);
    }
    if (isValidCode) {
      setShowLoader(true);
      getOrderDetails();
      setShowLoader(false);
    }
  }, [isValidCode])

  if (!orderData) return <div>Loading...</div>;

  return (
    <>
      {showLoader && <Loader />}
      <Stepper activeStep="overview" />
      <section className="wizard-container booking-view">
        <div className="wrapper">
          <div className="row wizard-content">
            <div className="column-12">
              <h3 className="mali-blue">{t("shoppingBasket")}</h3>
            </div>
          </div>

          <div className="row wizard-content">
            <div className="column-12 orderitems-container">
              {orderData.OrderItem && orderData.OrderItem.map(item => <RenderOrderItem item={item} key={item.key || item.Id}
                validationErrors={validationErrors} />)}
            </div>

            {(!masterData.organization.FreeOfCharge) && <div className="column-12 ordertotal-container">
              {showVoucherSec && <div className="voucher-container">
                <div className="voucher-title">{t("voucher")}</div>
                <div className="addVoucher">
                  <input type="text" value={voucherCode} onChange={event => setVoucherCode(event.target.value)} />
                  <button className="forward" type="button" onClick={checkVoucherCode}>{t("addVoucher")} <i className="fa fa-plus" aria-hidden="true"></i></button>
                </div>
              </div>}
              <div className="order-total">
                <div className="order-label">
                  <span className="order-text">{t("totalAmount")}</span>
                  <span className="order-note">{t("vatIncluded")}</span>
                </div>
                <div className="order-price">
                  {currency()} {orderData.TotalPrice.toFixed(2)}
                </div>
              </div>
            </div>}

            <div className="column-12 postaddress-container">
              {/* <a className="address-title" onClick={toggleAddressBlocks}>{t("yourAddress")}</a> */}
              <div className="row post-address-container">
                <AddressBlockRO addressTitle="postalAddress" address={addressPost} businessPartner={businessPartner} />
              </div>
              <div className="address-edit"><button onClick={editAddress}>{t("editAddress")} <i className="fa fa-pencil" aria-hidden="true"></i></button></div>
            </div>

            <div className={`column-12 agb-container${validationErrors.includes('agbCheckbox') ? ' required-error' : ''}`}>
              <input type="checkbox" id="agbCheckbox"
                onClick={evt => setIsAgbAccepted(evt.target.checked)}
                checked={isAgbAccepted} />{t("acceptAGB", { lessorName: masterData.organization.Name })}&nbsp;
              <a target="_blank" href={`/api/public/BusinessUnit/${businessUnitId()}/getCurrentGTC`}>{t("agb")}</a>
            </div>

            {validationErrors.length > 0 && <div className="column-12 overviewerror-container error">
              <div className="overviewerror-message">
                {t("validationMessage")}
              </div>
            </div>}

          </div>

        </div>
      </section>
      {
        <FixedBottom>
          <div className="wrapper">
            <div className="row fixedBottom-content">
              <div className="column-8 fixedBottom-right">
                <div className="fixedBottom-buttons btn-forward">
                  <Link to={`/search`} onClick={onClickBookMore} className="order-bookmore">
                    {t("bookMore")} <i className="fa fa-plus" aria-hidden="true"></i>
                  </Link>
                  {(!masterData.organization.FreeOfCharge) && (orderData.TotalPrice > 0) && <Link onClick={onClickPayment} to={`/wizard/payment`} className="order-payment">
                    {t("payment")} <i className="fa fa-arrow-right" aria-hidden="true"></i>
                  </Link>}
                  {(masterData.organization.FreeOfCharge || orderData.TotalPrice == 0) && <Link onClick={onClickFinalize} to={`/wizard/cofirmation`} className="order-finalize">
                    {t("finalize")} <i className="fa fa-arrow-right" aria-hidden="true"></i>
                  </Link>}
                </div>
              </div>
              <div className="column-4 fixedBottom-left">
                <div className="fixedBottom-buttons btn-back">
                  <a onClick={showCancelOrder} className="order-cancel">
                    <i className="fa fa-times-circle" aria-hidden="true"></i> {t("cancel")}
                  </a>
                </div>
              </div>
            </div>
          </div>
        </FixedBottom>
      }
    </>
  );
}

export default BWOverview;